export interface PermissionListFilter {
  page?: number | null;
  count?: number | null;
}

export const defaultPermissionListFilter: PermissionListFilter = {
  page: 0,
  count: 10,
};
